module.exports = __webpack_public_path__ + "img/21.3.TP.fec20ef3.png";